import { render } from "./CommentBox.vue?vue&type=template&id=42878b0d&scoped=true"
import script from "./CommentBox.vue?vue&type=script&lang=js"
export * from "./CommentBox.vue?vue&type=script&lang=js"

import "./CommentBox.vue?vue&type=style&index=0&id=42878b0d&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42878b0d"]])

export default __exports__